interface QuestionCardSkeletonProps {
  isEditPage?: boolean;
  index: number;
}

export function QuestionCardSkeleton({
  isEditPage = false,
  index,
}: QuestionCardSkeletonProps) {
  const generateRandomWidth = (seed: number) => {
    const widths = ["w-1/3", "w-1/2", "w-2/3", "w-3/4", "w-5/6", "w-full"];
    return widths[seed % widths.length];
  };

  const multipleChoiceOptionsCount = (index % 3) + 3;
  const isMultipleChoice = index % 2 === 0;

  const answerOptions = Array.from(
    { length: multipleChoiceOptionsCount },
    (_, i) => ({
      id: `skeleton-${index}-answer-${i}`,
      width: generateRandomWidth(index + i),
    }),
  );

  return (
    <div
      id={`question-skeleton-card-${index}`}
      className={`${isEditPage ? "bg-base-300" : "bg-neutral"} my-4 rounded-lg p-md shadow-sm`}
    >
      <div
        id={`question-skeleton-header-${index}`}
        className="flex flex-row items-center justify-between"
      >
        <div className="skeleton h-6 w-24" />
        <div
          id={`question-skeleton-actions-${index}`}
          className="flex flex-row items-center justify-end"
        >
          {isEditPage && (
            <div className="skeleton ml-md h-8 w-8 rounded-full" />
          )}
          <div className="skeleton ml-md h-6 w-16 rounded-full" />
          <div className="skeleton ml-sm h-6 w-20 rounded-full" />
          <div className="skeleton ml-sm h-6 w-6" />
          <div className="skeleton ml-md h-6 w-6" />
        </div>
      </div>

      <div id={`question-skeleton-content-${index}`} className="mt-4 font-bold">
        <div className={`skeleton h-6 ${generateRandomWidth(index)}`} />
      </div>

      <div
        id={`question-skeleton-tip-${index}`}
        className="mt-2 text-md italic"
      >
        <div className="skeleton h-4 w-2/3" />
      </div>

      {isMultipleChoice ? (
        <div
          id={`question-skeleton-answers-multiple-${index}`}
          className="mt-4 space-y-1"
        >
          {answerOptions.map((answer) => (
            <div key={answer.id} className="ms-1 flex items-center gap-2">
              <div className="skeleton h-6 w-6" />
              <div className={`skeleton h-4 ${answer.width}`} />
            </div>
          ))}
        </div>
      ) : (
        <div
          id={`question-skeleton-answers-freetext-${index}`}
          className="mt-4"
        >
          <div className="skeleton mb-2 h-4 w-32" />
          <div className="skeleton h-5 w-full" />
        </div>
      )}
    </div>
  );
}
